<template>
  <div class="wrapper" @click.stop>
    <img class="fail-image" :src="image" alt="" />
    <div class="close iconfont icon-cha" @click="bindclose"></div>
    <div class="btn" @click="bindclose"></div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {
    image() {
      let imageData = {
        4: 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-04/11f1c4a6b33a8a4b126dbfa7662aca24_wh=825_1095.webp',
        5: 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-04/e890446260373083c5981da59156c80c_wh=825_1095.webp',
        6: 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-04/56927901032a0640f2a2472484c2f01c_wh=825_1155.webp'
      }

      return imageData[this.info.project_state] || imageData[3]
    }
  },
  created() {},
  methods: {
    bindclose() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);

  .fail-image {
    width: 275px;
    height: 365px;
    object-fit: contain;
  }

  .btn {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0%);
    bottom: 24px;
    width: 227px;
    height: 40px;
  }

  .close {
    position: absolute;
    left: 50%;
    bottom: -30px;
    transform: translate(-50%, 100%);
    box-sizing: border-box;
    width: 24px;
    height: 24px;
    border: 1px solid #ffffff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
}
</style>
